'use strict';

var cov_3m72418o2 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/comment/comment.js',
        hash = '72ed07ab5f54ed09c2480b193474428556cdae88',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/comment/comment.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 30
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 8
                },
                end: {
                    line: 8,
                    column: 37
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 30
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 0
                },
                end: {
                    line: 21,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 18
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 11
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 7
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommentController = function () {
    function CommentController() {
        _classCallCheck(this, CommentController);

        cov_3m72418o2.f[0]++;
        cov_3m72418o2.s[0]++;

        this.editable = false;
    }

    _createClass(CommentController, [{
        key: 'save',
        value: function save() {
            cov_3m72418o2.f[1]++;
            cov_3m72418o2.s[1]++;

            this.data.$save(['content']);
            cov_3m72418o2.s[2]++;
            this.editable = false;
        }
    }]);

    return CommentController;
}();

cov_3m72418o2.s[3]++;


angular.module('app').component('comment', {
    templateUrl: 'app/components/comment/comment.html',
    controller: CommentController,
    bindings: {
        data: '<'
    }
});